// Bunad data with descriptions from bunadstuggu.no
// Images will be added as they become available

import dovrebunadMain from "@/assets/bunader/dovrebunad/dovrebunad-main.jpg";
import dovrebunad1 from "@/assets/bunader/dovrebunad/dovrebunad-1.jpg";
import dovrebunad2 from "@/assets/bunader/dovrebunad/dovrebunad-2.jpg";
import dovrebunad3 from "@/assets/bunader/dovrebunad/dovrebunad-3.jpg";
import dovrebunad4 from "@/assets/bunader/dovrebunad/dovrebunad-4.jpg";
import dovrebunad5 from "@/assets/bunader/dovrebunad/dovrebunad-5.jpg";
import dovrebunad6 from "@/assets/bunader/dovrebunad/dovrebunad-6.jpg";

import grafferdraktMain from "@/assets/bunader/grafferdrakt/grafferdrakt-main.jpg";
import grafferdrakt1 from "@/assets/bunader/grafferdrakt/grafferdrakt-1.jpg";
import grafferdrakt2 from "@/assets/bunader/grafferdrakt/grafferdrakt-2.jpg";
import grafferdrakt3 from "@/assets/bunader/grafferdrakt/grafferdrakt-3.jpg";
import grafferdrakt4 from "@/assets/bunader/grafferdrakt/grafferdrakt-4.jpg";
import grafferdrakt5 from "@/assets/bunader/grafferdrakt/grafferdrakt-5.jpg";
import grafferdrakt6 from "@/assets/bunader/grafferdrakt/grafferdrakt-6.jpg";

import lundebybunadMain from "@/assets/bunader/lundebybunad/lundebybunad-main.jpg";
import lundebybunad1 from "@/assets/bunader/lundebybunad/lundebybunad-1.jpg";
import lundebybunad2 from "@/assets/bunader/lundebybunad/lundebybunad-2.jpg";
import lundebybunad3 from "@/assets/bunader/lundebybunad/lundebybunad-3.jpg";
import lundebybunad4 from "@/assets/bunader/lundebybunad/lundebybunad-4.jpg";
import lundebybunad5 from "@/assets/bunader/lundebybunad/lundebybunad-5.jpg";
import lundebybunad6 from "@/assets/bunader/lundebybunad/lundebybunad-6.jpg";
import lundebybunad7 from "@/assets/bunader/lundebybunad/lundebybunad-7.jpg";
import lundebybunad8 from "@/assets/bunader/lundebybunad/lundebybunad-8.jpg";

import frueskodraktenMain from "@/assets/bunader/frueskodrakten/frueskodrakten-main.jpg";
import frueskodrakten1 from "@/assets/bunader/frueskodrakten/frueskodrakten-1.jpg";
import frueskodrakten2 from "@/assets/bunader/frueskodrakten/frueskodrakten-2.jpg";
import frueskodrakten3 from "@/assets/bunader/frueskodrakten/frueskodrakten-3.jpg";
import frueskodrakten4 from "@/assets/bunader/frueskodrakten/frueskodrakten-4.jpg";
import frueskodrakten5 from "@/assets/bunader/frueskodrakten/frueskodrakten-5.jpg";

import leksvikdraktenMain from "@/assets/bunader/leksvikdrakten/leksvikdrakten-main.jpg";
import leksvikdrakten1 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-1.jpg";
import leksvikdrakten2 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-2.jpg";
import leksvikdrakten3 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-3.jpg";
import leksvikdrakten4 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-4.jpg";
import leksvikdrakten5 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-5.jpg";
import leksvikdrakten6 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-6.jpg";
import leksvikdrakten7 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-7.jpg";
import leksvikdrakten8 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-8.jpg";
import leksvikdrakten9 from "@/assets/bunader/leksvikdrakten/leksvikdrakten-9.jpg";

import herredraktMain from "@/assets/bunader/herredrakt/herredrakt-main.jpg";
import herredrakt1 from "@/assets/bunader/herredrakt/herredrakt-1.jpg";
import herredrakt2 from "@/assets/bunader/herredrakt/herredrakt-2.jpg";
import herredrakt3 from "@/assets/bunader/herredrakt/herredrakt-3.jpg";
import herredrakt4 from "@/assets/bunader/herredrakt/herredrakt-4.jpg";
import herredrakt5 from "@/assets/bunader/herredrakt/herredrakt-5.jpg";

export interface Bunad {
  id: string;
  title: string;
  shortDescription: string;
  fullDescription: string[];
  colors: string[];
  images: string[];
  features: string[];
}

export const bunader: Bunad[] = [
  {
    id: "grafferdrakt",
    title: "Grafferdrakt",
    shortDescription: "Tradisjonell drakt fra Røros-regionen med karakteristiske broderier og farger.",
    fullDescription: [
      "Grafferdrakten har sitt utspring fra Graffer gard i Lom. Røros Husflidlag, eid av familien Tønseth, lagde mønster med brodert liv ca i 1950.",
      "Den er brodert på klede fra Gudbrandsdalens uldvarefabrik. Brodert liv, stakk, lue og veske. Trøye (jakke) eller cape syes i klede.",
      "Vi leverer drakten ferdig fra oss. Ønsker du å sy selv, leverer vi materialpakke. Det er også mulig å kjøpe brodert materialpakke.",
      "Grafferdrakten broderes og monteres i Norge. Vi forhandler bunadsølv og sko til alle våre bunader."
    ],
    colors: ["Blå", "Svart"],
    images: [grafferdraktMain, grafferdrakt1, grafferdrakt2, grafferdrakt3, grafferdrakt4, grafferdrakt5, grafferdrakt6],
    features: [
      "Brodert liv, stakk, lue og veske",
      "Trøye (jakke) eller cape i klede",
      "Klede fra Gudbrandsdalens uldvarefabrik",
      "Broderes og monteres i Norge"
    ]
  },
  {
    id: "dovrebunad",
    title: "Dovrebunad",
    shortDescription: "Elegant bunad inspirert av Dovre-fjellene, med vakre detaljer og god passform.",
    fullDescription: [
      "Bunaden er utformet med utgangspunkt i broderiet på ei lue fra Tofte på Dovre. Bunaden ble lagd omkring 1930, men skaperen er ukjent.",
      "Røros Husflidlag, eid av familien Tønseth, startet produksjon av Dovrebunad i ca 1950. De farget opp garnet selv, og de fargene har vi prøvd å holde på.",
      "Det er brodert på klede fra Gudbrandsdalens uldvarefabrik. Brodert liv, stakk, lue og veske. Trøye (jakke) eller cape syes i klede. Skjorte i bomull eller lin med nupereller brukes til bunaden.",
      "Vi leverer bunaden ferdig fra oss. Bunaden kan kjøpes som materialpakke hvis du ønsker å sy selv. Ønsker du å montere selv, kan det kjøpes brodert materialpakke.",
      "Bunaden broderes og monteres i Norge. Vi forhandler bunadsølv og sko til alle våre bunader."
    ],
    colors: ["Blå", "Svart", "Offwhite"],
    images: [dovrebunadMain, dovrebunad1, dovrebunad2, dovrebunad3, dovrebunad4, dovrebunad5, dovrebunad6],
    features: [
      "Brodert liv, stakk, lue og veske",
      "Trøye (jakke) eller cape i klede",
      "Skjorte i bomull eller lin med nupereller",
      "Broderes og monteres i Norge"
    ]
  },
  {
    id: "lundebybunad",
    title: "Lundebybunad",
    shortDescription: "Klassisk bunad med røtter fra Lundeby, kjent for sitt tidløse design.",
    fullDescription: [
      "Lundebybunaden var opprinnelig en gave fra kunstneren Alf Lundeby til ei venninne på ca 1930-tallet.",
      "Røros Husflidlag, eid av familien Tønseth, startet produksjon av Lundebybunaden i ca 1950. De farget opp garnet selv. Vi ser i dag at fargene i vår Lundebybunad går mer mot fjellfarger enn andre produsenter. Mønsteret på bunaden er det samme.",
      "Den er brodert på klede fra Gudbrandsdalens uldvarefabrik. Brodert liv, stakk, lue og veske.",
      "Trøye (jakke) eller cape syes i klede. Vi leverer bunaden ferdig fra oss. Ønsker du å sy selv, leverer vi materialpakke. Det er også mulig å kjøpe brodert materialpakke.",
      "Bunaden broderes og monteres i Norge. Vi forhandler bunadsølv og sko til alle våre bunader."
    ],
    colors: ["Blå", "Svart", "Offwhite"],
    images: [lundebybunadMain, lundebybunad1, lundebybunad2, lundebybunad3, lundebybunad4, lundebybunad5, lundebybunad6, lundebybunad7, lundebybunad8],
    features: [
      "Brodert liv, stakk, lue og veske",
      "Trøye (jakke) eller cape i klede",
      "Fjellfarger unike for Bunadstuggu",
      "Broderes og monteres i Norge"
    ]
  },
  {
    id: "frueskodrakten",
    title: "Frueskodrakten",
    shortDescription: "Raffinert drakt med særpreg, perfekt for festlige anledninger.",
    fullDescription: [
      "Frueskodrakten er designet av Jenny Fiskum fra Snåsa. Fruesko eller Marisko som den også heter, er en fredet orkide som det vokser mye av i Snåsa kommune.",
      "Vi kjøpte designet av Jenny Fiskum i 2015. Etter det har vi utarbeidet mønster, og fått laget eget sølv til drakten.",
      "Drakten er brodert på to-skaft ull fra Gudbrandsdalens uldvarefabrik. Brodert liv, stakk, veske og belte. Cape syes i to-skaft ull.",
      "Vi leverer drakten ferdig fra oss. Frueskodrakten broderes og monteres i Norge."
    ],
    colors: ["Svart", "Offwhite"],
    images: [frueskodraktenMain, frueskodrakten1, frueskodrakten2, frueskodrakten3, frueskodrakten4, frueskodrakten5],
    features: [
      "Brodert liv, stakk, veske og belte",
      "Cape i to-skaft ull",
      "Eget designet sølv",
      "Broderes og monteres i Norge"
    ]
  },
  {
    id: "leksvikdrakten",
    title: "Leksvikdrakten",
    shortDescription: "Tradisjonell drakt fra Leksvik-området med unike broderimønstre.",
    fullDescription: [
      "Leksvikdrakten er skapt av Olga og Inger Gangstad, og ble lansert i 1992. Vi kjøpte mønster og design fra Inger Gangstad i 2020.",
      "Leksvikdrakten har brodert liv, stakk, veske og belte. Den er nydelig med alle sine markblomster.",
      "Det er komponert eget sølv til bunaden. Blomstermotivet er utgangspunkt i sølvet. Det er innslag av Leksvik thulitt i sølvet. Thulitt er Norges nasjonalstein.",
      "Vi leverer bunaden ferdig fra oss. Leksvikdrakten broderes og monteres i Norge."
    ],
    colors: ["Blå", "Svart", "Offwhite"],
    images: [leksvikdraktenMain, leksvikdrakten1, leksvikdrakten2, leksvikdrakten3, leksvikdrakten4, leksvikdrakten5, leksvikdrakten6, leksvikdrakten7, leksvikdrakten8, leksvikdrakten9],
    features: [
      "Brodert liv, stakk, veske og belte",
      "Markblomster som broderimotiv",
      "Eget sølv med Leksvik thulitt",
      "Broderes og monteres i Norge"
    ]
  },
  {
    id: "herredrakt",
    title: "Herredrakt",
    shortDescription: "Stilren herredrakt med fokus på kvalitet og klassisk eleganse.",
    fullDescription: [
      "Herredrakten ble laget som en drakt som skal passe til både Graffer og Lundeby. Vi har laget jakken i 2 farger, svart og hvit.",
      "Vesten kan du velge stoff selv. Den røde vesten er sydd i ulldamask fra Gudbrandsdalen. Men vi har flere varianter i silke fra Tyrihans.",
      "Stoffet i herredrakten er i herreklede fra Gudbrandsdalen. Som en fin fargeklatt har vi silkeskjerf fra Tyrihans i halsen. Kan bruke både sølvknapper og tinnknapper."
    ],
    colors: ["Svart jakke", "Hvit jakke"],
    images: [herredraktMain, herredrakt1, herredrakt2, herredrakt3, herredrakt4, herredrakt5],
    features: [
      "Passer til Graffer og Lundeby",
      "Valgfritt stoff til vest",
      "Herreklede fra Gudbrandsdalen",
      "Silkeskjerf fra Tyrihans"
    ]
  }
];

export const getBunadById = (id: string): Bunad | undefined => {
  return bunader.find(bunad => bunad.id === id);
};
